module.exports = __webpack_public_path__ + "img/ban.a00ab0e8.svg";